import React from "react";
import { Table } from "antd";

export default function ChannelTable({ data, loading }) {
  const columns = [
    {
      title: "Canal",
      dataIndex: "source",
      key: "source",
    },
    {
      title: "Page Views",
      dataIndex: "pageViews",
      key: "pageViews",
    },
    {
      title: "Sessões",
      dataIndex: "sessions",
      key: "sessions",
    },
    {
      title: "Cliques WhatsApp",
      dataIndex: "whatsappClicks",
      key: "whatsappClicks",
    },
    {
      title: "CTR WhatsApp (%)",
      dataIndex: "whatsappCtr",
      key: "whatsappCtr",
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      loading={loading}
      pagination={false}
      scroll={{ x: 900 }}
    />
  );
}